import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { CartProvider } from "@/context/CartContext";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import HomePage from "@/pages/HomePage";
import ShopPage from "@/pages/ShopPage";
import ProductPage from "@/pages/ProductPage";
import AboutPage from "@/pages/AboutPage";
import ContactPage from "@/pages/ContactPage";
import FaqPage from "@/pages/FaqPage";
import LegalPage from "@/pages/LegalPage";
import CartPage from "@/pages/CartPage";

function ScrollToTop() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const timer = setTimeout(() => {
        document.querySelector(hash)?.scrollIntoView({ behavior: "smooth" });
      }, 400);
      return () => clearTimeout(timer);
    }
    window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
}

function App() {
  return (
    <div className="App">
      <CartProvider>
        <BrowserRouter>
          <ScrollToTop />
          <Header />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/kauppa" element={<ShopPage />} />
            <Route path="/tuote/:slug" element={<ProductPage />} />
            <Route path="/tietoja-meista" element={<AboutPage />} />
            <Route path="/yhteystiedot" element={<ContactPage />} />
            <Route path="/ukk" element={<FaqPage />} />
            <Route path="/ostoskori" element={<CartPage />} />
            <Route path="/maksu-ja-toimitus" element={<LegalPage pageKey="maksu-ja-toimitus" />} />
            <Route path="/tietosuojakaytanto" element={<LegalPage pageKey="tietosuojakaytanto" />} />
            <Route path="/evastekaytanto" element={<LegalPage pageKey="evastekaytanto" />} />
            <Route path="/kayttoehdot" element={<LegalPage pageKey="kayttoehdot" />} />
            <Route path="/peruutusoikeus" element={<LegalPage pageKey="peruutusoikeus" />} />
            <Route path="*" element={<HomePage />} />
          </Routes>
          <Footer />
          <Toaster position="bottom-right" richColors />
        </BrowserRouter>
      </CartProvider>
    </div>
  );
}

export default App;
